//const ApiLink = `https://hidden-wildwood-71739.herokuapp.com`;

// const ApiLink = `http://localhost:4000`;

const ApiLink = process.env.REACT_APP_SERVER_URL

export default ApiLink
